module.exports = __webpack_public_path__ + "img/MobileSelectedFeedbackGood.1ac8c36b.png";